module.exports = __webpack_public_path__ + "media/images/front/icon_bell-ff84af40dbc025c4b84924a6898cc1c8.png";